import React from 'react';

interface Props {
    price: string
    isPriceOld: boolean
    priceOld: string
    showNds: boolean
}

export class PriceProduct extends React.Component<Props, {}> {


    componentDidMount() {
    }

    render() {

        let price: string = this.props.price
        let isPriceOld: boolean = this.props.isPriceOld
        let priceOld: string = this.props.priceOld
        let showNds:boolean =this.props.showNds

        return (
            <div className="goods-content">
                <div className="goods-content-price">
                    {price ? <span className="new-price">{price} BYN {showNds ? <small>без НДС</small>: null}</span> : null}
                    {isPriceOld ? <span className="old-price">{priceOld} BYN {showNds ? <small>без НДС</small>:null}</span> : null}
                </div>
            </div>
        )
    }
}

